const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        {
          title: "类型: ",
          banding: "SendType",
          value: "短信",
          dataType: "Type",
          dataMap: {
            1: "短信",
            2: "邮箱",
            3: "微信"
          }
        },
        { title: "定制号码: ", banding: "SendTo", value: "13285965698" }
      ]
    },
    {
      rowList: [
        {
          title: "消息内容: ",
          banding: "Content",
          value: "香港正能量入仓,通关状态(正常/异常),深证正能量送货,下单审核"
        }
      ]
    }
  ]
};
export { itemsData };
